/**
 * De opzet van een dakpanset (stap 22, services/dakpan.py), om te lezen: de
 * brontekst, de vier deelteksten met hun bouwstenen, de overlap tussen twee
 * deelteksten (waarover, en wat de tweede toevoegt), de modelreconstructie
 * in zes zinnen met de bronnen, en de causale eindvraag.
 *
 * Voor de beheerder (bij het maken en bewerken) en de leerkracht (bij een
 * tekst); de leerling ziet dit niet.
 */
import React from 'react';

const kop = { fontSize: 15, margin: '16px 0 8px' };
const lijst = { margin: '0 0 0 20px', lineHeight: 1.6 };

export const OVERLAPFUNCTIES = {
  precisering: 'precisering (wie, waar, wanneer)', verklaring: 'verklaring (waarom)', gevolg: 'gevolg',
  volgorde: 'volgorde in de tijd', perspectief: 'ander perspectief',
};

export function DakpanOpzet({ opzet }) {
  if (!opzet) return null;
  const delen = opzet.delen || [];
  const bouwstenen = opzet.bouwstenen || [];
  const overlap = opzet.overlap || [];
  const reconstructie = opzet.reconstructie || [];
  const titelVan = (n) => delen.find(d => d.nummer === n)?.titel;
  return (
    <div style={{ fontSize: 14 }} data-testid="dakpanopzet">
      {opzet.bron?.titel && <p><strong>Gemaakt van:</strong> {opzet.bron.titel}</p>}
      <h4 style={kop}>De vier deelteksten en hun bouwstenen</h4>
      <ol style={lijst}>
        {[1, 2, 3, 4].map(n => (
          <li key={n}>
            {titelVan(n) || `Deeltekst ${n}`}
            <ul style={{ ...lijst, listStyle: 'none', marginLeft: 0 }}>
              {bouwstenen.filter(b => b.code?.startsWith(String(n))).map(b => (
                <li key={b.code}><code>[{b.code}]</code> {b.inhoud}</li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
      {overlap.length > 0 && (
        <>
          <h4 style={kop}>De overlap (voor de luisterronde)</h4>
          <ul style={lijst}>
            {overlap.map((o, i) => (
              <li key={i}>
                {o.van && o.naar ? `Deel ${o.van} en ${o.naar}: ` : ''}{o.wat}
                {o.functie && <span className="text-muted"> — deel {o.naar || 'twee'} voegt toe: {OVERLAPFUNCTIES[o.functie] || o.functie}</span>}
              </li>
            ))}
          </ul>
        </>
      )}
      {reconstructie.length > 0 && (
        <>
          <h4 style={kop}>Modelreconstructie in {reconstructie.length} zinnen (voor de leerkracht)</h4>
          <ol style={lijst}>
            {reconstructie.map((r, i) => (
              <li key={i}>{r.zin} {r.bronnen?.length > 0 && <span className="text-muted">[{r.bronnen.join(' + ')}]</span>}</li>
            ))}
          </ol>
        </>
      )}
      {opzet.eindvraag && <p className="mt-8"><strong>Causale eindvraag:</strong> {opzet.eindvraag}</p>}
    </div>
  );
}
